"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadColorUpdater = void 0;
const ColorUpdater_1 = require("./ColorUpdater");
function loadColorUpdater(tsParticles) {
    tsParticles.addParticleUpdater("color", () => new ColorUpdater_1.ColorUpdater());
}
exports.loadColorUpdater = loadColorUpdater;
